
<div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
<button *ngIf="hasCancelButton" (click)="close()" class="cansel-btn">انصراف</button>
<div class="message">{{errorMessage}}</div>
